import React, { Component } from 'react';
import { JsonEditor as Editor } from 'jsoneditor-react';
import 'jsoneditor-react/es/editor.min.css';
import Dialog from '../components/Dialog';
import { Button } from 'reactstrap';
import  Viewer  from '../components/Viewer';

class JsonEditor extends Component {
    state = {
       
         showJSONEditor: true   
      };

okClick=() =>{
     if (this.props["okClick"])
     {
        this.props["okClick"]();
     }
   

}
handleChange=(e)=>{
  //  console.log(this,e,this.props);
    if (this.props["handleChange"])
    {
       this.props["handleChange"](e);
    }
}
    render() {
        var myJson=this.props.config;

        
        if (this.state.showJSONEditor)
        {
        return (
            <Dialog>
            <Editor
                value={myJson}
                theme="ace/theme/github"
                onChange={this.handleChange}
            />
            <Button color="primary" onClick={this.okClick}>
                Ok
              </Button>
            </Dialog>
        );
        }
        else
        {
            return (<Viewer></Viewer>);
        }
    }


}

export default JsonEditor;